import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=4db98eff&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db98eff')) {
      api.createRecord('4db98eff', component.options)
    } else {
      api.reload('4db98eff', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=4db98eff&", function () {
      api.rerender('4db98eff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-40bbnnjNxCQQ2/JS/comp/FavElement.vue"
export default component.exports